// The sign-in logo — which logo the screens before sign-in draw.
//
// Look and Feel → Sign-in logo (settings/server/branding.js) is the site's
// own logo for the sign-in, two-factor and password screens; without one
// they show the product's Zebra Stride logo. /api/branding/theme answers
// `signInLogo`: a content version of the saved logo, or null.
//
// The answer is CACHED in this browser so a returning visitor's first paint
// is already the right logo (the accent does the same — app-shell/accent.js).
// The cache is a paint optimisation, never the source of truth: every visit
// asks again and the answer overwrites it.
//
// Pure — no imports, no React — so the static suite proves it.

export const SIGN_IN_LOGO_KEY = 'zi_sign_in_logo';
export const SIGN_IN_LOGO_URL = '/api/branding/sign-in-logo';
const NONE = 'none';
const VERSION_RE = /^[0-9a-f]{6,40}$/;

// What this browser last heard: a version string, null (the site has none),
// or undefined (never asked here — the page waits for the answer).
export function readSignInLogo() {
  try {
    const v = globalThis.localStorage?.getItem(SIGN_IN_LOGO_KEY);
    if (v === NONE) return null;
    return VERSION_RE.test(v || '') ? v : undefined;
  } catch { return undefined; }
}

export function cacheSignInLogo(version) {
  try {
    globalThis.localStorage?.setItem(SIGN_IN_LOGO_KEY, VERSION_RE.test(version || '') ? version : NONE);
    return true;
  } catch { return false; }
}

// The theme answer → the version to draw (null = the product's logo).
export const signInLogoFromTheme = (theme) => (VERSION_RE.test(theme?.signInLogo || '') ? theme.signInLogo : null);

export const signInLogoSrc = (version) => `${SIGN_IN_LOGO_URL}?v=${encodeURIComponent(version)}`;
